import { h } from 'preact';
import styles from './ToggleButton.module.scss';
export function ToggleButton({ toggle, setToggle, text, selectedFilterCount }) {
    return (h("button", { class: styles.toggleBtn, onClick: () => setToggle(!toggle), "aria-expanded": toggle },
        h("span", null, text),
        selectedFilterCount != null && selectedFilterCount > 0 && (h("span", { class: styles.filterCount }, selectedFilterCount)),
        h("svg", { class: toggle ? styles.arrowOpen : styles.arrow, width: "12", height: "7", viewBox: "0 0 12 7", fill: "none" },
            h("path", { d: "M5.65375 6.7075L0 1.05375L1.05375 0L5.65375 4.6L10.2537 0L11.3075 1.05375L5.65375 6.7075Z", fill: "currentColor" }))));
}
